<template>
  <div class="default-modal product-request-modal">
    <div class="default-modal__header">
      <button type="button" class="default-modal__close settings-modal__close" @click="$emit('closeAll')">
        <IconComponent name="close" />
      </button>
      <h4 class="default-modal__title">Заявка</h4>
    </div>
    <form @submit.prevent.stop class="default-modal__body">
      <h5>Опишите вашу проблему для его решения</h5>
      <InputComponent
        v-model="form.phone.value"
        :errors="form.phone.errors"
        placeholder="Номер телефона"
        mask="+7 (###) ###-##-##"
      />
      <TextareaComponent
        v-model="form.title.value"
        :errors="form.title.errors"
        placeholder="Описание..."
        rows="6"
      />
      <button @click="submit" class="btn btn--black btn--lg">
        <IconComponent v-if="loading" name="loading" />
        <span v-else> Отправить </span>
      </button>
      <span class="default-modal__documents">
        Нажимая на кнопку, вы соглашаетесь с
        <router-link :to="{ name: 'about', params: { link: 'termsOfUse' } }">
          условиями использования
        </router-link>
        и
        <router-link :to="{ name: 'about', params: { link: 'publicOffer' } }">
          публичной офертой
        </router-link></span
      >
    </form>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";
import InputComponent from "components/inputs/InputComponent.vue";
import TextareaComponent from "components/inputs/TextareaComponent.vue";
import NotificationModal from "components/modal/components/NotificationModal.vue";
import POST from "@/graphql/mutations/FeedbackCreate.graphql";
export default {
  name: "ProductRequestModal",
  components: { TextareaComponent, InputComponent, IconComponent },
  data() {
    return {
      loading: false,
      form: {
        phone: {
          value: null,
          errors: [],
        },
        title: {
          value: null,
          errors: [],
        },
      },
    };
  },
  methods: {
    resetErrors() {
      Object.keys(this.form).forEach((key) => {
        this.form[key].errors = [];
      });
    },
    submit() {
      this.loading = true;
      this.resetErrors();
      this.$apollo
        .mutate({
          mutation: POST,
          context: {
            headers: {
              Authorization: "Bearer " + this.$store.state.apollo_token,
            },
          },
          variables: {
            phone: this.form.phone.value,
            type: 2,
            title: this.form.title.value,
          },
        })
        .then(() => {
          this.loading = false;
          this.$store.state._modals = [];
          this.$store.state._modals.push({
            component: NotificationModal,
            options: {
              title: "Спасибо!",
              description: "Ваша заявка на рассмотрении",
            },
          });
        })
        .catch(({ graphQLErrors }) => {
          this.parseGqlErrors(graphQLErrors);
          this.loading = false;
        });
    },
    parseGqlErrors(graphQLErrors) {
      graphQLErrors.forEach((err) => {
        if (err.extensions.category === "validation") {
          Object.keys(err.extensions.validation).forEach((key) => {
            if (this.form[key]) {
              this.form[key].errors.push(err.extensions.validation[key][0]);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="stylus">
.product-request-modal {
  max-width: 540px;
}
</style>
